export const deviceSizes = {
  xsmall: 280,
  small: 430,
  medium: 700,
  large: 980,
  xLarge: 1440,
} as const;

export const contestDeviceSizes = {
  xsmall: 375 - 1,
  small: 430, // iPhone 14pro max 기준
  medium: 700,
  large: 980,
} as const;
